webpackJsonp([1],{

/***/ 354:
/* exports provided: default */
/* all exports used */
/*!***********************************************!*\
  !*** ./screens/App/screens/GMap/component.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(/*! react-router */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(/*! react-helmet */ 352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_custom_event__ = __webpack_require__(/*! custom-event */ 111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_custom_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_custom_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_MapOverlayPoint__ = __webpack_require__(/*! MapOverlayPoint */ 800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_MapStoryPoint__ = __webpack_require__(/*! MapStoryPoint */ 801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_MapEventPoint__ = __webpack_require__(/*! MapEventPoint */ 799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__google_map_style_json__ = __webpack_require__(/*! ./google-map-style.json */ 812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__google_map_style_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__google_map_style_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MapQuery__ = __webpack_require__(/*! ./MapQuery */ 802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ZoomControl__ = __webpack_require__(/*! ./ZoomControl */ 803);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var GMap = function (_PureComponent) {
  _inherits(GMap, _PureComponent);

  function GMap(props) {
    _classCallCheck(this, GMap);

    var _this = _possibleConstructorReturn(this, (GMap.__proto__ || Object.getPrototypeOf(GMap)).call(this, props));

    _this.markers = [];
    _this.mapInitialized = false;
    _this.centerPoint = false;
    return _this;
  }

  _createClass(GMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.gapiKey !== '') {
        if (global.document.getElementById('gmaps-api') === null) {
          global.initMap = this.initializeMap.bind(this);

          var s = global.document.createElement('script');
          s.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=' + this.props.gapiKey + '&callback=window.initMap';
          s.type = 'text/javascript';
          s.id = 'gmaps-api';
          global.document.getElementsByTagName('head')[0].appendChild(s);
        } else {
          this.initializeMap();
        }
      }
    }
  }, {
    key: 'initializeMap',
    value: function initializeMap() {
      /* eslint-disable no-new, global-require */
      if (!this.mapInitialized) {
        this.centerPoint = new global.google.maps.LatLng(38.743, -90.289);

        var width = global.innerWidth || global.document.documentElement.clientWidth || global.document.body.clientWidth;

        var styledMap = new global.google.maps.StyledMapType(__WEBPACK_IMPORTED_MODULE_8__google_map_style_json___default.a);
        var mapOptions = {
          center: this.centerPoint,
          disableDefaultUI: true,
          zoom: width > 768 ? 15 : 13,
          minZoom: 3,
          maxZoom: 20,
          scrollwheel: true
        };

        this.map = new global.google.maps.Map(this.mapDiv, mapOptions);
        global.googleMap = this.map;

        // Associate the styled map with the MapTypeId and set it to display.
        this.map.mapTypes.set('styled_map', styledMap);
        this.map.setMapTypeId('styled_map');

        // Add custom zoom controls
        var zoomControlDiv = global.document.createElement('div');
        new __WEBPACK_IMPORTED_MODULE_10__ZoomControl__["a" /* default */](zoomControlDiv, this.map);

        zoomControlDiv.index = 1;
        this.map.controls[global.google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);

        var CustomMarker = __webpack_require__(/*! ./CustomMarker */ 794).default;

        // Add static marker for where Michael Brown was shot.
        new CustomMarker(new global.google.maps.LatLng(38.73847, -90.27387), this.map, {
          markup: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_MapOverlayPoint__["a" /* default */], { text: 'Michael Brown was killed' })
        });

        this.mapInitialized = true;
        this.popuplateMap();
      }
    }
  }, {
    key: 'popuplateMap',
    value: function popuplateMap() {
      /* eslint-disable no-new, global-require */
      this.clearMap();

      if (this.mapInitialized && (this.props.stories.entities.length > 0 || this.props.events.entities.length > 0)) {
        var CustomMarker = __webpack_require__(/*! ./CustomMarker */ 794).default;

        // Add story and event data points.
        var points = this.props.stories.entities.concat(this.props.events.entities);
        for (var i = 0; i < points.length; i += 1) {
          var point = points[i];
          // Only stories have a URL.
          var isStory = Object.prototype.hasOwnProperty.call(point, 'entityUrl');

          if (point.fieldLocation) {
            var location = JSON.parse(point.fieldLocation.toString('utf-8'));
            var latlng = new global.google.maps.LatLng(location[0].lat, location[0].lng);

            this.markers.push(new CustomMarker(latlng, this.map, {
              markup: isStory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_MapStoryPoint__["a" /* default */], Object.assign({}, point, {
                map: this.map,
                history: this.props.history
              })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_MapEventPoint__["a" /* default */], Object.assign({}, point, { map: this.map })),
              hasMouseEvents: true
            }));
          }
        }
      }
    }
  }, {
    key: 'clearMap',
    value: function clearMap() {
      for (var i = 0; i < this.markers.length; i += 1) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      this.popuplateMap();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'main',
        { className: 'site-content site-content--bottom-left-gradient' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,
          { title: 'Map' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta', { property: 'og:title', content: 'Map | Ferguson Voices' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link', { rel: 'dns-prefetch', href: '//maps.googleapis.com' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            role: 'presentation',
            className: 'site-content__screen site-content__screen--fixed',
            onClick: function onClick(event) {
              if (_this2.map && event.target.tagName.toLowerCase() !== 'button') {
                _this2.map.setOptions({ scrollwheel: true });
                global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_4_custom_event___default.a('mapModalsClosed'));
              }
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: function ref(elem) {
              return _this2.mapDiv = elem;
            }, id: 'map', className: 'map' })
        )
      );
    }
  }]);

  return GMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GMap.defaultProps = {
  gapiKey: '',
  stories: {
    entities: []
  },
  events: {
    entities: []
  }
};
GMap.propTypes = {
  gapiKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  stories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    entities: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      entityLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldSubtitle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldShortDescription: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldThemeColor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldLocation: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
      fieldImage3: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      entityUrl: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        alias: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
      })
    }))
  }),
  events: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    entities: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      entityLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldDate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldImage: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      fieldLocation: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
      body: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
    }))
  })
};


/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__MapQuery__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* withRouter */])(GMap)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 794:
/* exports provided: default */
/* all exports used */
/*!**************************************************!*\
  !*** ./screens/App/screens/GMap/CustomMarker.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(/*! react-dom */ 357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var CustomMarker = function (_global$google$maps$O) {
  _inherits(CustomMarker, _global$google$maps$O);

  function CustomMarker(latlng, map, args) {
    _classCallCheck(this, CustomMarker);

    var _this = _possibleConstructorReturn(this, (CustomMarker.__proto__ || Object.getPrototypeOf(CustomMarker)).call(this, latlng, map, args));

    _this.latlng = latlng;
    _this.args = args;
    _this.setMap(map);
    return _this;
  }

  _createClass(CustomMarker, [{
    key: 'onAdd',
    value: function onAdd() {
      if (!this.container) {
        this.container = global.document.createElement('div');
        this.container.className = 'map__point center center--both';

        if (this.args.hasMouseEvents) {
          this.getPanes().floatPane.appendChild(this.container);
        } else {
          this.getPanes().overlayLayer.appendChild(this.container);
        }

        if (this.args.markup) {
          __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.render(this.args.markup, this.container);
        }
      }
    }
  }, {
    key: 'draw',
    value: function draw() {
      if (this.container) {
        var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

        if (point) {
          this.container.style.left = point.x + 'px';
          this.container.style.top = point.y + 'px';
        }
      }
    }
  }, {
    key: 'onRemove',
    value: function onRemove() {
      if (this.container) {
        this.container.parentNode.removeChild(this.container);
        this.container = null;
      }
    }
  }]);

  return CustomMarker;
}(global.google.maps.OverlayView);

/* harmony default export */ __webpack_exports__["default"] = (CustomMarker);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 799:
/* exports provided: default */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./screens/App/components/MapEventPoint/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_custom_event__ = __webpack_require__(/*! custom-event */ 111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_custom_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_custom_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Html__ = __webpack_require__(/*! Html */ 211);





/* eslint-disable react/no-danger */
var EventPoint = function EventPoint(_ref) {
  var entityLabel = _ref.entityLabel,
      fieldDate = _ref.fieldDate,
      fieldImage = _ref.fieldImage,
      body = _ref.body,
      map = _ref.map;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'map__event theme--blue-black' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: 'map__target btn btn--circle btn--circle--small',
        onClick: function onClick(event) {
          event.preventDefault();
          global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_2_custom_event___default.a('mapModalsClosed'));
          event.target.parentNode.parentNode.classList.add('is-active');
          map.setOptions({ scrollwheel: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'visually-hidden' },
        entityLabel
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'map__more-info' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_Html__["a" /* default */],
        { className: 'map__marker map__marker--event-thumbnail center center--both' },
        fieldImage
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'map__tooltip tooltip tooltip--event center center--vertically' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'tooltip__scrollable' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tooltip__content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'tooltip__title h3 h3--medium' },
              entityLabel
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', {
              className: 'tooltip__description h3 h3--medium',
              dangerouslySetInnerHTML: { __html: fieldDate }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_Html__["a" /* default */],
              { className: 'wysiwyg wysiwyg--small' },
              body
            )
          )
        )
      )
    )
  );
};
/* eslint-enable react/no-danger */

/* harmony default export */ __webpack_exports__["a"] = (EventPoint);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 800:
/* exports provided: default */
/* exports used: default */
/*!*********************************************************!*\
  !*** ./screens/App/components/MapOverlayPoint/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var OverlayPoint = function OverlayPoint(_ref) {
  var text = _ref.text;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'center center--both' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'map__marker map__marker--callout center center--both h3 h3--tiny centered theme--blue-black' },
      text
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OverlayPoint);

/***/ }),

/***/ 801:
/* exports provided: default */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./screens/App/components/MapStoryPoint/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_custom_event__ = __webpack_require__(/*! custom-event */ 111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_custom_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_custom_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Html__ = __webpack_require__(/*! Html */ 211);





/* eslint-disable react/no-danger, react/no-unused-prop-types */


var StoryPoint = function StoryPoint(_ref) {
  var entityLabel = _ref.entityLabel,
      fieldSubtitle = _ref.fieldSubtitle,
      fieldShortDescription = _ref.fieldShortDescription,
      fieldThemeColor = _ref.fieldThemeColor,
      fieldImage3 = _ref.fieldImage3,
      entityUrl = _ref.entityUrl,
      history = _ref.history,
      map = _ref.map;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'map__story theme--' + fieldThemeColor },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: 'map__target btn btn--circle btn--circle--small btn--radiating',
        onClick: function onClick(event) {
          event.preventDefault();
          global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_2_custom_event___default.a('mapModalsClosed'));
          event.target.parentNode.parentNode.classList.add('is-active');
          map.setOptions({ scrollwheel: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'visually-hidden' },
        entityLabel
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        href: entityUrl.alias,
        onClick: function onClick(event) {
          event.preventDefault();
          history.push(entityUrl.alias);
        },
        className: 'map__more-info'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_Html__["a" /* default */],
        { className: 'map__marker map__marker--story-thumbnail center center--both' },
        fieldImage3
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'map__tooltip tooltip tooltip--story center center--vertically' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'tooltip__svg svg-wrapper svg-wrapper--left-small-double-quote' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'svg',
            { 'aria-hidden': 'true', focusable: 'false' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '#left-double-quote' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_Html__["a" /* default */],
          { className: 'tooltip__quote h3 h3--medium theme--white' },
          fieldShortDescription
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'tooltip__title h4 h4--small theme--white' },
          entityLabel
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', {
          className: 'tooltip__description h3 h3--tiny',
          dangerouslySetInnerHTML: { __html: fieldSubtitle }
        })
      )
    )
  );
};
/* eslint-enable react/no-danger, react/no-unused-prop-types */

/* harmony default export */ __webpack_exports__["a"] = (StoryPoint);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 802:
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./screens/App/screens/GMap/MapQuery.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(/*! react-apollo */ 91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
var _templateObject = _taggedTemplateLiteral(['\n  query mapPoints(\n    $storyFilter: NodeQueryFilterInput!\n    $eventFilter: NodeQueryFilterInput!\n  ) {\n    stories: nodeQuery(filter: $storyFilter) {\n      entities {\n        entityLabel\n        fieldSubtitle\n        fieldShortDescription\n        fieldThemeColor\n        fieldLocation\n        fieldImage3\n        entityUrl {\n          alias\n        }\n      }\n    }\n    events: nodeQuery(filter: $eventFilter) {\n      entities {\n        entityLabel\n        fieldDate\n        fieldImage\n        fieldLocation\n        body\n      }\n    }\n  }\n'], ['\n  query mapPoints(\n    $storyFilter: NodeQueryFilterInput!\n    $eventFilter: NodeQueryFilterInput!\n  ) {\n    stories: nodeQuery(filter: $storyFilter) {\n      entities {\n        entityLabel\n        fieldSubtitle\n        fieldShortDescription\n        fieldThemeColor\n        fieldLocation\n        fieldImage3\n        entityUrl {\n          alias\n        }\n      }\n    }\n    events: nodeQuery(filter: $eventFilter) {\n      entities {\n        entityLabel\n        fieldDate\n        fieldImage\n        fieldLocation\n        body\n      }\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["default"])(_templateObject);

var MapQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["graphql"])(query, {
  options: function options() {
    return {
      variables: {
        storyFilter: {
          type: 'story',
          status: true
        },
        eventFilter: {
          type: 'event',
          status: true
        }
      }
    };
  },
  props: function props(_ref) {
    var _ref$data = _ref.data,
        stories = _ref$data.stories,
        events = _ref$data.events;
    return {
      stories: stories,
      events: events
    };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MapQuery);

/***/ }),

/***/ 803:
/* exports provided: default */
/* exports used: default */
/*!*************************************************!*\
  !*** ./screens/App/screens/GMap/ZoomControl.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var ZoomControl = function ZoomControl(div, map) {
  var controlDiv = div;
  var zoomClasses = 'map__control btn btn--circle btn--shadow btn--zoom';
  controlDiv.className = 'map__controls hide-on-mobile';

  // Add the control wrapper.
  var controlWrapper = global.document.createElement('div');
  controlDiv.appendChild(controlWrapper);

  // Create zoom in button.
  var zoomInButton = global.document.createElement('button');
  zoomInButton.className = zoomClasses + ' btn--zoom-in';
  controlWrapper.appendChild(zoomInButton);

  // Create zoom out button.
  var zoomOutButton = global.document.createElement('button');
  zoomOutButton.className = zoomClasses + ' btn--zoom-out';
  controlWrapper.appendChild(zoomOutButton);

  // Setup the click event listener - zoomIn
  global.google.maps.event.addDomListener(zoomInButton, 'click', function () {
    map.setZoom(map.getZoom() + 1);
  });

  // Setup the click event listener - zoomOut
  global.google.maps.event.addDomListener(zoomOutButton, 'click', function () {
    map.setZoom(map.getZoom() - 1);
  });

  // Prevent focus from sticking.
  global.google.maps.event.addDomListener(zoomInButton, 'mousedown', function (event) {
    event.preventDefault();
  });
  global.google.maps.event.addDomListener(zoomOutButton, 'mousedown', function (event) {
    event.preventDefault();
  });

  map.addListener('zoom_changed', function () {
    var currentZoomLevel = map.getZoom();
    if (currentZoomLevel < map.maxZoom) {
      zoomInButton.className = zoomClasses + ' btn--zoom-in';
    } else {
      zoomInButton.className = zoomClasses + ' btn--zoom-in is-disabled';
    }

    if (currentZoomLevel > map.minZoom) {
      zoomOutButton.className = zoomClasses + ' btn--zoom-out';
    } else {
      zoomOutButton.className = zoomClasses + ' btn--zoom-out is-disabled';
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (ZoomControl);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 812:
/* no static exports found */
/* exports used: default */
/*!********************************************************!*\
  !*** ./screens/App/screens/GMap/google-map-style.json ***!
  \********************************************************/
/***/ (function(module, exports) {

module.exports = [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"weight":"1"},{"lightness":"-35"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"weight":"1"},{"visibility":"simplified"},{"color":"#9b9b99"}]},{"featureType":"administrative.locality","elementType":"labels.text.stroke","stylers":[{"weight":"3"},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"},{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#e9e8e3"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#e9e8e3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#e9e8e3"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#eeede9"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"on"},{"weight":"1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#e9e8e3"},{"weight":"5"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"weight":"2"},{"gamma":"1"},{"color":"#dcdbd6"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#333333"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#eeede9"},{"weight":"6"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#eeede9"},{"weight":"1"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"color":"#ebebeb"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#dcdbd6"}]},{"featureType":"road.local","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#f6f6f6"},{"weight":"5"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.rail","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#e1e0db"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e1e0db"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#e1e0db"},{"gamma":"1"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#e9e8e3"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}]

/***/ })

});


// WEBPACK FOOTER //
// GMap/component.378f639eae8f3a21b8cf.js